// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@insite/content-library/Widgets/Basic/Slideshow";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        margin-top: -40px;
        position: absolute;
        width: 100%;
    `,
};

slideshowStyles.dotButton = {
    css: css`
        padding: 0;
        margin: 0 4px;
        background: ${getColor("common.border")};
        &:hover,
        &:active {
            background: ${getColor("common.border")};
            border: 1px solid #ffffff;
        }
        &:focus {
            outline: none;
        }
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 1px solid #ffffff;
        min-height: auto;
        display: inline-block;
    `,
};
